import React from "react";
import { Row, Col, Card, ListGroup, Offcanvas, Container } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { StruSoftLogo } from "../assets/StruSoftLogo";
import { UserInitialsIcon } from "../assets/UserInitialsIcon";
import LoginButton from "./LoginButton";
import { useTranslation } from "react-i18next";
import { SXEditField } from "@common/components/ui-components/SXEditField";
import { updateUserProfile } from "../features/user/userSlice";
import { useDevConfig } from "../features/config/configSlice";
declare const REACT_APP_VERSION: string;

export interface SXOffCanvasMenuProps {
  handleCloseOffCanvas: () => void;
  showOffCanvas: boolean;
  user?: { name?: string; signature?: string; organization: string } | null;
  isSalesUser?: boolean;
  onShowBenchmark?: () => void;
  onShowReleaseNotes?: () => void;
}

export const SXOffCanvasMenu = (props: SXOffCanvasMenuProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { user, isSalesUser = false, onShowBenchmark, onShowReleaseNotes } = props;
  const isDevConfig = useDevConfig();

  return (
    <Offcanvas id="offcanvas-menu" show={props.showOffCanvas} onHide={props.handleCloseOffCanvas} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title style={{ fontSize: 14 }}>
          <Row>
            <Col>
              Developed by
              <StruSoftLogo />
            </Col>

            <Col xs={4} className="text-end">
              <span id="version_number_span">{`version ${REACT_APP_VERSION}`}</span>
            </Col>
          </Row>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {user && isDevConfig && (
          <Card className="offcanvas-user-profile-card m-2 p-2">
            <Card.Body className="d-flex align-items-center">
              <Container>
                <Row className="container-row align-items-center justify-content-center">
                  <Col xs={4} className="ps-0">
                    <UserInitialsIcon user={user} width={120} height={120} className="offcanvas-user-profile-icon" />
                  </Col>
                  <Col className="pe-0">
                    <Row className="container-row">
                      <Col className="editfield-label ps-3">{t("name")}</Col>
                      <SXEditField
                        disabled
                        fullWidth
                        textAlign="left"
                        id="user-profile-name"
                        fontSize={14}
                        type="text"
                        val={user.name ?? ""}
                        onUpdate={(val) => dispatch(updateUserProfile({ name: String(val) }))}
                      />
                    </Row>
                    <Row className="container-row">
                      <Col className="editfield-label mt-1 ps-3">{t("meta_data.signature")}</Col>
                      <SXEditField
                        fullWidth
                        textAlign="left"
                        id="user-profile-signature"
                        fontSize={14}
                        type="text"
                        val={user.signature ?? ""}
                        onUpdate={(val) => dispatch(updateUserProfile({ signature: String(val) }))}
                      />
                    </Row>
                    {props.user && props.user.organization && (
                      <Row className="container-row">
                        <Col className="editfield-label mt-1 ps-3">{t("organization")}</Col>
                        <SXEditField
                          disabled
                          fullWidth
                          textAlign="left"
                          id="user-profile-organization"
                          fontSize={14}
                          type="text"
                          val={user.organization ?? ""}
                          onUpdate={() => {}}
                        />
                      </Row>
                    )}
                  </Col>
                </Row>
              </Container>
            </Card.Body>
          </Card>
        )}
        <ListGroup className="offcanvas-listgroup m-2">
          <span>
            <ListGroup.Item onClick={() => window.open("https://strusoft.freshdesk.com/", "_blank")}>
              {t("contact_support")}
            </ListGroup.Item>

            <ListGroup.Item
              onClick={() => {
                props.handleCloseOffCanvas();
                onShowReleaseNotes?.();
              }}
            >
              {t("release_notes")}
            </ListGroup.Item>

            <ListGroup.Item onClick={() => window.open("https://simplex-docs.onstrusoft.com/", "_blank")}>
              {t("documentation")}
            </ListGroup.Item>
            <ListGroup.Item onClick={() => window.open("https://portal.onstrusoft.com", "_blank")}>
              StruSoft Portal
            </ListGroup.Item>
            {isSalesUser && onShowBenchmark && (
              <ListGroup.Item
                onClick={() => {
                  props.handleCloseOffCanvas();
                  onShowBenchmark();
                }}
              >
                Payload benchmark
              </ListGroup.Item>
            )}
          </span>
          <span>
            <ListGroup.Item>
              <LoginButton flat icon />
            </ListGroup.Item>
          </span>
        </ListGroup>
      </Offcanvas.Body>
    </Offcanvas>
  );
};
